export function getSentryErrorSampleRate(): number {
  return 1.0;
}
